import React from "react";
import { ArrowRight, HardHat, Key, Zap } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Maîtrise d'Œuvre",
  description: "Neuf et rénovation, conception et exécution, logements collectifs ou individuels, nous assurons le suivi technique et le pilotage complet de vos projets.",
  tag: "Particuliers & Promoteurs",
  icon: HardHat,
  href: "/maitrise-d-oeuvre",
  tagClassName: "text-card-foreground flex flex-col gap-6 rounded-xl py-6 h-full border-border bg-card transition-all duration-300 hover:bg-muted/30 hover:border-secondary hover:shadow-md hover:-translate-y-1 overflow-hidden relative bg-cover bg-center !bg-[url(https://nsdb.10web.cloud/wp-content/uploads/2026/04/IMG_8032-scaled.jpg)]"
}, {
  title: "Audit Énergétique",
  description: "En maison individuelle, 1ère étape indispensable pour bien appréhender vos travaux de rénovation énergétique et bénéficier des aides financières.",
  tag: "Particuliers",
  icon: Zap,
  href: "/audit-energetique",
  tagClassName: "text-card-foreground flex flex-col gap-6 rounded-xl py-6 h-full border-border bg-card transition-all duration-300 hover:bg-muted/30 hover:border-secondary hover:shadow-md hover:-translate-y-1 overflow-hidden relative bg-cover bg-center !bg-[url(https://nsdb.10web.cloud/wp-content/uploads/2026/03/Combien-de-sacs-de-laine-de-roche-pour-isoler-100m²-682x455-1.png)]"
}, {
  title: "AMO Livraisons",
  description: "Assistance aux promoteurs pour la livraison de leurs programmes immobiliers.Gestion des réserves et garantie d'une expérience acquéreur irréprochable.",
  tag: "Promoteurs",
  icon: Key,
  href: "/amo-livraisons",
  tagClassName: "text-card-foreground flex flex-col gap-6 rounded-xl py-6 h-full border-border bg-card transition-all duration-300 hover:bg-muted/30 hover:border-secondary hover:shadow-md hover:-translate-y-1 overflow-hidden relative bg-cover bg-center !bg-[url(https://nsdb.10web.cloud/wp-content/uploads/2026/03/8176d1ac5006df82aedc175915e406a4.jpg)]"
}];
export default function NosPolesDexpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="nos-poles-dexpertise" ref={ref} className="bg-background text-foreground transition-opacity duration-700 opacity-100 ![padding:128px_32px_64px_32px]">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 text-center space-y-4">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">Nos 3 Pôles d'Expertise</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg !w-[750px]">Une approche globale et structurée pour garantir la réussite de vos projets de construction et de rénovation. Conception, Exécution, Livraison : nous intervenons sur toutes les phases de votre projet grâce à nos 3 missions complémentaires.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, i) => <Link key={i} to={service.href} className="block group h-full" data-index={i}>
              <Card className={`${service.tagClassName || ""} h-full border-border bg-card transition-all duration-300 hover:bg-muted/30 hover:border-secondary hover:shadow-md hover:-translate-y-1 overflow-hidden relative`}>
                {(i === 0 || i === 1 || i === 2) && <div className="absolute inset-0 bg-white/70 z-0" />}
                {i === 1 && <input type="file" className="absolute bottom-0 right-0 w-[80px] h-[59px] z-20 cursor-pointer opacity-0" onClick={e => e.stopPropagation()} />}
                <div className="absolute top-0 left-0 w-full h-1 bg-primary/0 group-hover:bg-accent transition-colors duration-300" />
                
                <CardHeader className="pb-4 relative z-10">
                  <div className="flex justify-between items-start mb-4">
                    <div className="p-3 rounded-lg bg-secondary/20 group-hover:bg-secondary/40 transition-colors duration-300">
                      <service.icon className="w-8 h-8 text-primary transition-transform duration-500 group-hover:scale-110 group-hover:rotate-3" strokeWidth={1.5} />
                    </div>
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary/10 text-primary border border-primary/20">
                      {service.tag}
                    </span>
                  </div>
                  <CardTitle className="text-xl md:text-2xl group-hover:text-primary transition-colors duration-300">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                
                <CardContent className="pb-8 relative z-10">
                  <CardDescription className="text-base leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>

                <CardFooter className="mt-auto pt-0 relative z-10">
                  <div className="flex items-center text-sm font-medium text-primary group-hover:text-primary/80 transition-colors">
                    En savoir plus
                    <ArrowRight className="ml-2 w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
                  </div>
                </CardFooter>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}